export default "__VITE_ASSET__Cq$eguT3__"